module.exports = __webpack_public_path__ + "img/icon-30.8d4647d9.svg";